import store from '../store'
import axios from 'axios'

export default async (to, from, next) => {
    if (to.query && (to.query.QUERY || to.query.query)) {

        const {data} = await axios.get(`${window.config.appUrl}/api/oauth`, {
            params: {
                QUERY: to.query.QUERY ? to.query.QUERY : to.query.query,
                VERSION: to.query.QUERY ? 'v1' : 'v2'
            }
        })

        // Error
        if (data.errorCode && data.errorCode === 4003) {
            // Redirect home.
            next({name: 'error-4003'})
            return
        }

        // Save the token.
        store.dispatch('auth/saveToken', {
            token: data.token
        })

        // Fetch the user.
        await store.dispatch('auth/fetchUser')

        // Wrong market for user
        if (store.state.auth.user.market.abbreviation !== window.config.market) {
            next({ name: 'error-4004' })
            return
        }

        // No lending point?
        if (store.state &&
            store.state.auth &&
            store.state.auth.user &&
            store.state.auth.user.missing_lending_point) {
            // Redirect home.
            next({name: 'error-4001'})
            return
        }

        store.state.auth.user.login_from_open = true
    }

    next()
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/check-open-auth.js